export const apolloProtocol = 'apollo';
export const apolloHost = 'jore4';
export const apolloPath = '/query';
